import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { LocationOnOutlined, HomeOutlined, CloudOutlined } from "@material-ui/icons"

import "./skeletonAbout.css"

const SkeletonAbout = () => {
  return (
    <div className="rightbarInfo">
        <div style={{width: '100%', height: '1rem', marginBottom: '1rem'}}>
            <Skeleton className='rightbarInfoItem' />
        </div>
        <div style={{width: '100%', height: '1rem', marginBottom: '1rem'}}>
            <Skeleton className='rightbarInfoItem' />
        </div>
        <div style={{width: '100%', height: '1rem', marginBottom: '1rem'}}>
            <Skeleton className='rightbarInfoItem' />
        </div>
    </div>
  )
}

export default SkeletonAbout